import {
  jspreadsheetLicense,
  zendeskFields,
  importTemplateAssets,
} from './environment.shared';

export const environment = {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  appVersion: 'v' + require('../../package.json').version + '-test',
  production: false,
  enableSW: true,
  moduleId: 'L2SkjmdhJng-',
  moduleName: 'DPR Web Test',
  coreModule: {
    name: 'Core',
    description: 'Account Management',
    locationUrl: 'https://core.test.lautec.com/',
    favIconUrl:
      'https://assets.test.lautec.com/module-icons/favicon-core-module.svg',
  },
  assets: importTemplateAssets,
  dprApi: {
    endpoint: 'https://app-lautec-dpr-api-test-west-eu.azurewebsites.net',
    /**
     * Scopes you add here will be prompted for user consent during sign-in.
     * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
     * For more information about OIDC scopes, visit:
     * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
     */
    scopes: ['https://lautecb2ctest.onmicrosoft.com/apis/default'],
  },
  filesApi: {
    endpoint: 'https://lautec-files-api-test.azurewebsites.net/v1',
    /**
     * Scopes you add here will be prompted for user consent during sign-in.
     * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
     * For more information about OIDC scopes, visit:
     * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
     */
    scopes: ['https://lautecb2ctest.onmicrosoft.com/apis/default'],
  },
  coreApi: {
    endpoint: 'https://api.core.test.lautec.com/v1',
    /**
     * Scopes you add here will be prompted for user consent during sign-in.
     * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
     * For more information about OIDC scopes, visit:
     * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
     */
    scopes: ['https://lautecb2ctest.onmicrosoft.com/apis/default'],
  },
  zendesk: {
    ...zendeskFields,
    envFieldValue: 'test', // this deployment's option tag: dev / test / demo / prod
  },
  crypto: {
    // TODO(Improvement) check for a better solution
    key: 'MTIzNDU2Nzg5MEFCQ0RFRkdISUpLTE1O',
    IV: 'MTIzNDU2Nzg=',
  },
  appInsights: {
    connectionString:
      'InstrumentationKey=effd1296-b211-4b31-925c-fc1d989d148a;IngestionEndpoint=https://northeurope-0.in.applicationinsights.azure.com',
  },
  jspreadsheet: jspreadsheetLicense,
  azureAdB2C: {
    clientId: 'f6141fa8-3071-4b27-85ac-8dbf8c4be5f5',
    b2cPolicies: {
      names: {
        signUpSignIn: 'b2c_1a_signin',
        passwordReset: 'b2c_1a_passwordreset',
      },
      authorities: {
        signUpSignIn: {
          authority:
            'https://identity.test.lautec.com/lautecb2ctest.onmicrosoft.com/b2c_1a_signin',
        },
        passwordReset: {
          authority:
            'https://identity.test.lautec.com/lautecb2ctest.onmicrosoft.com/b2c_1a_passwordreset',
        },
      },
      authorityDomain: 'identity.test.lautec.com',
    },
  },
};
